import { useCallback, useState } from "react";
import {
  Badge,
  Box,
  Grid,
  Tooltip,
  Typography,
  makeStyles,
} from "@material-ui/core";
import {
  columnNumberField,
  columnDateField,
  columnTextField,
} from "utils/tables-utils";
import ToolkitTable from "components/Cards/Tables/ToolkitTable";
import IconButtonLoader from "components/Buttons/IconButtonLoader";

import { Refresh as RefreshIcon } from "@material-ui/icons";
import { downloadXML } from "utils/tables-utils";

const useCustomStyles = makeStyles((theme) => ({
  badge: ({ status }) => ({
    backgroundColor:
      status === "OD pendente de entrada na loja"
        ? theme.palette.warning.light
        : status === "OD já integrada na loja"
        ? theme.palette.twitter.main
        : status === "Sucesso Integração MIS"
        ? theme.palette.success.main
        : status === "Erro de Integração MIS"
        ? theme.palette.warning.main
        : theme.palette.gray,
    height: 20,
    width: 20,
    borderRadius: 10,
    border: "none",
  }),
  root: {
    margin: "0 0.5rem",
  },
  buttonLabel: {
    display: "flex",
    alignItems: "center",
  },
  errorModal: {
    padding: theme.spacing(2, 4, 3),
    paddingBottom: 0,
    textAlign: "center",
  },
}));

const ColoredStatus = ({ status }) => {
  const classes = useCustomStyles({ status });

  return (
    <Tooltip
      title={status === undefined ? "sem status" : status}
      placement="top"
    >
      <Badge
        overlap="circle"
        badgeContent=" "
        color="primary"
        classes={{ badge: classes.badge, root: classes.root }}
      />
    </Tooltip>
  );
};

export default function TableRecebimentoODs({
  dataTable,
  totalRegistros,
  currentPage,
  currentSizePerPage,
  searchTitles,
  tableTitle,
  isMobile,
}) {
  const [searching, setSearching] = useState(false);

  const getColumnModel = () => [
    {
      dataField: "SucessoUltimaOcorrencia",
      text: "",
      align: "center",
      headerAlign: "center",
      formatter: (success, row) => {
        return (
          <ColoredStatus status={row.Status} textoOcorrencia={row.Status} />
        );
      },
    },
    columnTextField({
      dataField: "LojaDestino",
      text: "Loja Destino",
    }),
    columnDateField({
      dataField: "DataEmissaoNf",
      text: "Data Emissao NF",
    }),
    columnNumberField({
      dataField: "NumeroNf",
      text: "Numero NF",
    }),
    columnNumberField({
      dataField: "QtdVolumesNf",
      text: "Qtd. de Volumes NF",
      align: "right",
    }),
    columnTextField({
      dataField: "Mensagem",
      text: "Mensagem",
    }),
    {
      dataField: "XmlNoS3",
      text: "XML",
      headerAlign: "center",
      align: "center",
      isDummyField: true,
      formatter: downloadXML,
      csvExport: false,
    },
  ];

  const doSearch = useCallback(
    (page, sizePerPage) => {
      console.log("fazendo a nova busca");
      setSearching(true);

      searchTitles({}, page, sizePerPage).then(() => setSearching(false));
      console.log("busca concluida");
      console.log(dataTable);
    },
    [searchTitles]
  );

  const refresh = useCallback(() => {
    setSearching(true);

    searchTitles({}, currentPage, currentSizePerPage).then(() =>
      setSearching(false)
    );
  }, [currentPage, currentSizePerPage, searchTitles]);

  const handlePageChange = useCallback(
    (page, sizePerPage) => {
      doSearch(page, sizePerPage);
    },
    [doSearch]
  );

  const handleSizePerPageChange = useCallback(
    (sizePerPage, page) => {
      doSearch(page, sizePerPage);
    },
    [doSearch]
  );

  const indexedData = dataTable?.map((data, index) => ({ Id: index, ...data }));

  return (
    <ToolkitTable
      searched={Boolean(dataTable)}
      keyField="Id"
      dataTable={indexedData}
      columnModel={getColumnModel()}
      headerTitle={`RecebimentoODs`}
      csvFileName="RecebimentoODs.csv"
      showSearch={false}
      pagination={{
        options: [25, 50, 100],
        defaultOption: currentSizePerPage,
        totalSize: totalRegistros,
        showTotal: true,
        page: currentPage,
        onPageChange: handlePageChange,
        sizePerPage: currentSizePerPage,
        onSizePerPageChange: handleSizePerPageChange,
        alwaysShowAllBtns: true,
      }}
      CustomHeader={() => (
        <Grid
          container
          className="pl-4"
          style={{ padding: "0 24px", marginBottom: "1rem" }}
        >
          <Grid item xs={isMobile ? 12 : 10}>
            <Box component={Typography} variant="h2" marginBottom="0!important">
              <Box component="span">{tableTitle}</Box>
              <IconButtonLoader
                size="medium"
                extraStyle={{
                  width: 24,
                  height: 24,
                  marginLeft: "0.3rem",
                }}
                title="Recarregar lista"
                onClick={refresh}
                icon={<RefreshIcon color="primary" />}
                aria-label="refresh"
                color="primary"
                disabled={searching}
              />
            </Box>
          </Grid>
        </Grid>
      )}
      bootstrapTableProps={{
        remote: true,
        onTableChange: () => {},
      }}
      showPrint
      loading={searching}
      notFoundTitle="Sua pesquisa não encontrou nenhum recebimento correspondente."
    />
  );
}
